


































































import { Vue, Component } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import FileInput from '@/components/common/inputs/FileInput.vue'

@Component({
  components: {
    FileInput,
    Loading: () => import('@/components/common/loadings/UploadLoading.vue')
  }
})
export default class DicomUpload extends Vue {
  $store!: ExStore
  file = {
    name: '',
    base64: ''
  }
  title = ''
  description = ''
  fileSelect = false
  loading = false

  get patientId() {
    return Number(this.$route.params.patientId)
  }

  async upload() {
    // TODO: エラー処理など。
    this.loading = true
    try {
      if (!this.file.base64) return
      await this.$api.dicom.create({
        patientId: this.patientId,
        payload: {
          title: this.title,
          description: this.description,
          fileName: this.file.name,
          fileContent: this.file.base64
        }
      })
      this.$router.push({ name: 'DicomTabIndex' })
      this.loading = false
    } catch (e) {
      console.error(e)
      this.loading = false
    }
  }
}
